import * as actions from './loginActions';

const loginReducers = {
  [actions.LOGIN_STORE_DATA]: (state, { payload }) => ({
    ...state,
    ...payload,
  }),
  [actions.LOGIN_SUCCESS]: () => ({}),
  [actions.LOGIN_STORE_EMAIL]: (state, { payload }) => {
    state.email = payload;
    return state;
  },
  [actions.LOGIN_UPDATE_MESSAGE]: (state, { payload }) => {
    state.loginMessage = payload;
    return state;
  },
  [actions.LOGIN_RESET_MESSAGE]: state => {
    delete state.loginMessage;
    return state;
  },
  [actions.LOGIN_CLEAR_STATE]: () => ({}),
  [actions.LOGIN_STORE_REDIRECT]: (state, { payload }) => {
    state.loginRedirect = payload;
    return state;
  },
};

export default {
  name: 'login',
  reducers: loginReducers,
};
